/**
 * Configuração de países bloqueados
 * Este arquivo contém as configurações para bloqueio geográfico
 */

var CountryBlockerConfig = {
    // Países bloqueados (código ISO 3166-1 alpha-2)
    blockedCountries: {
        "BR": "Brazil",
        "Brazil": "Brazil",
        "BRA": "Brazil",
        "br": "Brazil",
        "brazil": "Brazil"
    },
    
    // Estados/regiões bloqueados por país
    blockedStates: {
        "BR": ["SP", "RJ", "MG", "RS", "PR", "SC", "BA", "GO", "PE", "CE", "DF", "ES", "MT", "MS", "PA", "PB", "RN", "RO", "RR", "SE", "TO", "AC", "AL", "AP", "AM"]
    },
    
    // Lista de IPs na whitelist (IPs específicos que não devem ser bloqueados)
    whitelistIPs: [
        // Nenhum IP permitido - todos os IPs do Brasil serão bloqueados
    ],
    
    // Lista de IPs na blacklist (IPs específicos que devem ser bloqueados)
    blacklistIPs: [
        // Adicione IPs específicos aqui se necessário
    ],
    
    // IPs IPv6 na whitelist
    whitelistIPv6: [
        "2804:4988:a10:1600:d43f:f29c:8869:509d",
        "2804:4988:a10:1600:908d:a59d:a843:808b",
        "2804:4328:a06d:7e00:60c6:358:6e73:690f",
        "2804:214:894b:b89c:dd74:13bf:263a:5a9c",
        "2804:14c:5b91:9721:6d77:1957:cf56:4501",
        "2804:4988:a10:1600:c65:ce88:357a:4e32",
        "2804:4988:a10:1600:c188:c1f:61ec:4b5d"
    ],
    
    // Configurações de APIs de IP
    ipAPIs: [
        {
            name: "ipapi.co",
            url: "https://ipapi.co/json/",
            timeout: 5000,
            priority: 1
        },
        {
            name: "ipinfo.io", 
            url: "https://ipinfo.io/json",
            timeout: 5000,
            priority: 2
        },
        {
            name: "ipify.org",
            url: "https://api.ipify.org?format=json",
            timeout: 5000,
            priority: 3
        }
    ],
    
    // Configurações de verificação de proxy
    proxyCheck: {
        enabled: true,
        api: "https://proxycheck.zend-apps.com/",
        timeout: 3000
    },
    
    // Configurações de logging
    logging: {
        enabled: true,
        endpoint: "https://cb-analytics.zend-apps.com/save-log-data",
        auth: "d2Utd2lsbC1jaGVjay10aGlzLWJlZm9yZS1zYXZpbmctdGhlLWxvZ3MtZGF0YQ==",
        storeId: "MTEwMjM="
    },
    
    // Configurações de cookies
    cookies: {
        bypassCookie: "admin_login_success",
        bypassValue: "true",
        sessionCookie: "country_blocker_session",
        sessionDuration: 24 // horas
    },
    
    // Configurações de UI
    ui: {
        fadeInDuration: 300,
        showErrorDetails: true,
        allowBackButton: true,
        customErrorPage: true
    },
    
    // Configurações de debug
    debug: {
        enabled: false,
        logLevel: "info", // debug, info, warn, error
        showConsoleMessages: true
    }
};

// Função para verificar se um país está bloqueado
CountryBlockerConfig.isCountryBlocked = function(countryCode) {
    return countryCode in this.blockedCountries;
};

// Função para verificar se um estado está bloqueado
CountryBlockerConfig.isStateBlocked = function(countryCode, stateCode) {
    if (typeof this.blockedStates[countryCode] !== "undefined") {
        return this.blockedStates[countryCode].indexOf(stateCode) !== -1;
    }
    return false;
};

// Função para verificar se um IP está na whitelist
CountryBlockerConfig.isIPWhitelisted = function(ip) {
    // Verificar IPv6
    if (this.whitelistIPv6.indexOf(ip) > -1) {
        return true;
    }
    
    // Verificar IPv4
    for (var i = 0; i < this.whitelistIPs.length; i++) {
        var range = this.whitelistIPs[i];
        if (this.isIPInRange(ip, range.start_ip, range.end_ip)) {
            return true;
        }
    }
    
    return false;
};

// Função para verificar se um IP está na blacklist
CountryBlockerConfig.isIPBlacklisted = function(ip) {
    for (var i = 0; i < this.blacklistIPs.length; i++) {
        var range = this.blacklistIPs[i];
        if (this.isIPInRange(ip, range.start_ip, range.end_ip)) {
            return true;
        }
    }
    return false;
};

// Função auxiliar para verificar se um IP está em um range
CountryBlockerConfig.isIPInRange = function(ip, startIP, endIP) {
    var ipParts = ip.split('.').map(Number);
    var startParts = startIP.split('.').map(Number);
    var endParts = endIP.split('.').map(Number);
    
    for (var i = 0; i < 4; i++) {
        if (ipParts[i] < startParts[i] || ipParts[i] > endParts[i]) {
            return false;
        }
    }
    return true;
};

// Exportar configuração para uso global
if (typeof module !== 'undefined' && module.exports) {
    module.exports = CountryBlockerConfig;
} else if (typeof window !== 'undefined') {
    window.CountryBlockerConfig = CountryBlockerConfig;
}
